import * as moment from 'moment';

import { Component, Input } from '@angular/core';

import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';
import { EventPartInstructor, NonRepeatingEventPart } from '../../../../../../../../../../models/event-type';
import { propExists, propExistsAndIsNonEmpty } from '../../../../../../../../../../utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


enum Interval {
  daily = 'Daily',
  weekly = 'Weekly',
  biweekly = 'Biweekly',
  monthly = 'Monthly'
}


@Component({
  selector: 'app-quick-add-occurrences-modal',
  templateUrl: './quick-add-occurrences-modal.component.html',
  styleUrls: ['./quick-add-occurrences-modal.component.css']
})
export class QuickAddOccurrencesModalComponent {
  @Input() submitCallback: (eventParts: NonRepeatingEventPart[]) => undefined;

  public numDatesToAdd: number;
  public firstDate: string;
  public startTime: string;
  public durationMinutes: number;
  public interval: Interval = Interval.weekly;
  public instructors: EventPartInstructor[] = [];

  public errorMessage = '';

  public Interval = Interval;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {}

  public handleSubmit() {
    if (!propExists(this.numDatesToAdd)) {
      this.errorMessage = 'Please select a number of dates to add.';
      return;
    }
    if (!propExistsAndIsNonEmpty(this.firstDate)) {
      this.errorMessage = 'Please select a first date.';
      return;
    }
    if (!propExistsAndIsNonEmpty(this.startTime)) {
      this.errorMessage = 'Please select a start time.';
      return;
    }
    if (!propExists(this.durationMinutes)) {
      this.errorMessage = 'Please select a duration.';
      return;
    }

    if ((this.numDatesToAdd <= 0) || (this.numDatesToAdd > 400)) {
      this.errorMessage = 'The number of dates to add must be a number between 1 and 400.';
    }
    if ((this.durationMinutes <= 0) || (this.durationMinutes > 1440)) {
      this.errorMessage = 'The duration must be a number between 1 and 1440.';
    }

    const eventParts: NonRepeatingEventPart[] = [];
    let thisDate = moment(this.firstDate);
    for (let i = 0; i < this.numDatesToAdd; i++) {
      // Create a separate copy of the instructors for each occurrence, so that
      // editing one occurrence does not impact the others.
      const thisInstructors: EventPartInstructor[] = [];
      for (const instructor of this.instructors) {
        thisInstructors.push({...instructor});
      }

      eventParts.push({
        start_time: this.startTime,
        start_date: thisDate.format('YYYY-MM-DD'),
        duration_minutes: this.durationMinutes,
        instructors: thisInstructors,
        start_datetime_isoformat: null,
        end_datetime_isoformat: null
      });

      // Move the date forward by the chosen interval.
      if (this.interval === Interval.daily) {
        thisDate = thisDate.add(1, 'days');
      }
      else if (this.interval === Interval.weekly) {
        thisDate = thisDate.add(1, 'weeks');
      }
      else if (this.interval === Interval.biweekly) {
        thisDate = thisDate.add(2, 'weeks');
      }
      else if (this.interval === Interval.monthly) {
        thisDate = thisDate.add(1, 'months');
      }
    }

    this.submitCallback(eventParts);
    this.activeModal.close();
  }
}
